import type { Vec2 } from '../../../geo/types';
import type { Frame, MeshBuilder, VertexStyle } from '../../mesh/meshBuilder';
import { buildConventEnclosure, conventEnclosureRings } from './conventEnclosure';
import readings from './minderbroedersPlan.json';

export const friaryEnclosureRings = () => conventEnclosureRings(readings.walls);

export function buildFriaryEnclosure(
  builder: MeshBuilder,
  style: VertexStyle,
  frame: Frame,
  terrain: (p: Vec2) => number
): void {
  buildConventEnclosure(builder, style, frame, terrain, readings.walls);
}
